import React from 'react';

export default function Checkbox({
  label,
  name,
  value,
  onChange,
  onBlur,
  disabled,
  errors,
  touched,
}) {
  return (
    <div className="flex flex-col">
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {label}
      </label>
      <div className="h-[41px] flex items-center">
        <input
          id={name}
          name={name}
          type="checkbox"
          className="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          onBlur={onBlur}
          onChange={onChange}
          value={true}
          checked={value}
          disabled={disabled}
        />
      </div>
      {errors && touched && (
        <div className="text-red-500 text-sm mt-1">{errors}</div>
      )}
    </div>
  );
}
